import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=72ec9479"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"
import style0 from "./Notify.vue?vue&type=style&index=0&id=72ec9479&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ec9479')) {
      api.createRecord('72ec9479', component.options)
    } else {
      api.reload('72ec9479', component.options)
    }
    module.hot.accept("./Notify.vue?vue&type=template&id=72ec9479", function () {
      api.rerender('72ec9479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Notification/Notify.vue"
export default component.exports